module.exports = __webpack_public_path__ + "img/banner-k.1f5a20ad.png";